import { Button } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, MouseEvent, MouseEventHandler, useRef, useState } from "react";
import AliceCarousel, { Props } from "react-alice-carousel";
import styles from "./styles.module.scss";

type ControlType = "Left" | "Right";

const Control: FC<{
  type: ControlType;
  disabled?: boolean;
  onClick: MouseEventHandler;
  className?: string;
}> = ({ type, onClick, className, disabled }) => {
  return (
    <Button
      variant="primary_inverted"
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        className,
        "border border-neutral-50 !text-primary-800 !w-fit",
      )}
      size="md"
      iconStart={type}
    />
  );
};

const Carousel: FC<
  Props & {
    showButton?: boolean;
    withFadeOut?: boolean;
  }
> = ({
  items,
  activeIndex,
  showButton = true,
  withFadeOut = true,
  ...props
}) => {
  const [itemIndex, setItemIndex] = useState<number>(activeIndex || 0);
  const carousel = useRef<any>(undefined);

  const handleGoNext = (e: MouseEvent) => {
    carousel.current?.slideNext(e);
  };

  const handleGoPrevious = (e: MouseEvent) => {
    carousel.current?.slidePrev(e);
  };

  const handleSlideChanged = ({ item }: { item: number }) => {
    setItemIndex(item);
  };

  const fadeOutClass =
    "px-2m hidden m:flex absolute top-none h-full items-center";

  const leftControl = (
    <Control
      disabled={itemIndex === 0}
      onClick={handleGoPrevious}
      type="Left"
    />
  );

  const rightControl = (
    <Control
      disabled={Number(items?.length) - 1 === itemIndex}
      onClick={handleGoNext}
      type="Right"
    />
  );

  return (
    <div className="relative">
      {showButton && (
        <div className="flex justify-center gap-2xs mt-2s mb-s m:hidden px-s">
          {leftControl}
          {rightControl}
        </div>
      )}

      <AliceCarousel
        ref={carousel}
        items={items}
        onSlideChanged={handleSlideChanged}
        {...props}
      />
      {showButton && (
        <>
          <div
            className={clsx("m:left-none", fadeOutClass, {
              [styles.left_fade_out as string]: itemIndex !== 0 && withFadeOut,
            })}
          >
            {leftControl}
          </div>
          <div
            className={clsx("m:right-none", fadeOutClass, {
              [styles.right_fade_out as string]:
                Number(items?.length) - 1 !== itemIndex && withFadeOut,
            })}
          >
            {rightControl}
          </div>
        </>
      )}
    </div>
  );
};

export default Carousel;
